export default __webpack_public_path__ + "static/noah-853a0e865229c9e6d6acce3f780b79cf.png";